/* eslint-disable no-inner-declarations, no-unused-vars */
import matchHeight from 'jquery-match-height';

export default () => {

  const $leadership = $('.leadership');

  if ($leadership.length) {

    $('.leadership-person-content').matchHeight();

    const $mobileSelector = $leadership.find('.leadership-tabs-mobile');
    const $tabs = $leadership.find('[role="tab"]');
    const $panels = $leadership.find('[role="tabpanel"]');

    // tab links click
    $tabs.on('click', (e) => {
      e.preventDefault();
      activateTab($(e.currentTarget).attr('id'));
    });

    // mobile select change
    $mobileSelector.on('change', (e) => {
      e.preventDefault();
      activateTab($mobileSelector.val());
    });

    // active specific tab
    function activateTab(tab) {

      // deactive all tabs
      deactivateTabs();

      // active tab
      $(`#${tab}`)
        .removeAttr('tabindex')
        .attr({
          'aria-selected': 'true',
          'aria-expanded': 'true'
        })
      ;

      // activate mobile select
      $mobileSelector.val(tab);

      // show tab content
      $(`#${tab}-tab`).prop('hidden', false);
    }

    // deactive all tabs
    function deactivateTabs() {

      // clear mobile select value
      $mobileSelector.val('');

      // de-select link
      $tabs.attr({
        'tabindex': '-1',
        'aria-selected': 'false',
        'aria-expanded': 'false'
      });

      // hide all content panels
      $panels.prop('hidden', true);
    }

  }

};
